/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

import { rankingRule } from '../../../../../../util/constants/constants';

const useSortingEffect = ({
  navigationFetched,
  setSortRules,
  navigationItem,
  setRankingRuleCode,
}) => {
  const directionOptions = [{
    value: 'ASC',
    label: 'ASC',
  }, {
    value: 'DESC',
    label: 'DESC',
  }];

  const buildSorts = (item) => {
    const { virtualParams } = item;
    const mappedAttributes = virtualParams.sortRules.map(s => ({
      field: s.field,
      options: directionOptions,
      defaultValue: s.direction.toUpperCase(),
    }));
    if (virtualParams.rankingRuleCode) {
      mappedAttributes.push({
        field: rankingRule,
        defaultValue: virtualParams.rankingRuleCode,
        options: directionOptions,
      });
    }
    return mappedAttributes;
  };

  useEffect(() => {
    if (navigationFetched) {
      setSortRules(buildSorts(navigationItem));
      setRankingRuleCode(navigationItem.virtualParams.rankingRuleCode);
    }
  }, [navigationFetched]);
};

export default useSortingEffect;
